import React, { Component } from 'react'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Modal from 'react-bootstrap/Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleRight, faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import Description from '../task/Description'
import VideoAgreement from './agreement/VideoAgreement'
import PDFAgreement from './agreement/PDFAgreement'
import SignAgreement from './agreement/SignAgreement'

import './Agreement.css'


export async function checkAgreement(firestore, user, object) {
  if (!object) {
    return { needAgreement: false }
  }
  const { require_agreement } = object
  if (!require_agreement) {
    return { needAgreement: false }
  }
  if (!user) {
    return { needAgreement: true, }
  }
  const userAgreementRef = await firestore
    .collection('user')
    .doc(user.uid)
    .collection('agreement')
    .doc(require_agreement)
    .get()
  const agreementRef = await firestore
    .collection('agreement')
    .doc(require_agreement)
    .get()
  if (!agreementRef.exists) {
    throw new Error(`No agreement: ${require_agreement}`)
  }
  return {
    needAgreement: !(userAgreementRef.exists && userAgreementRef.data().agree),
    agreement: {
      id: agreementRef.id,
      data: agreementRef.data(),
    },
    userAgreement: userAgreementRef.exists ? {
      id: userAgreementRef.id,
      data: userAgreementRef.data(),
    } : null,
  }
}

class Agreement extends Component {
  constructor(props) {
    super(props)

    this.state = {
      disagreeDetail: false,
      details: {},
    }
  }

  agree() {
    this.saveUserAgreement({
      agree: true,
    }, (userAgreement) => {
      if (!userAgreement) {
        return
      }
      window.scrollTo(0, 0)
    })
  }

  disagree() {
    this.setState({
      disagreeing: true,
    }, () => {
      this.saveUserAgreement({
        agree: false,
      }, () => {
        this.setState({
          disagreeing: false,
          disagreeConfirm: false,
        })
      })
    })
  }

  confirmRequirement(requirement, value) {
    const requirements = this.props.agreement.data.requirements || []
    const oldRequirementInputs = (this.props.userAgreement || { data: {} }).data.requirements || {}
    const requirementInputs = Object.assign({}, oldRequirementInputs)
    requirementInputs[requirement.id] = value || { updated: Date.now(), }
    const agree = !this.isRequirementDisabled(requirements.length, requirementInputs)
    this.saveUserAgreement({
      requirements: requirementInputs,
      agree,
    }, (userAgreement) => {
      if (!userAgreement) {
        return
      }
      if (agree) {
        window.scrollTo(0, 0)
        this.setState({
          disagreeDetail: false,
          agreeResult: true,
        })
      }
    })
  }

  saveUserAgreement(userParams, callback) {
    this.performSaveUserAgreement(userParams)
      .then((userAgreement) => {
        if (callback) {
          callback(userAgreement)
        }
        if (!this.props.onChange) {
          return
        }
        this.props.onChange(!userParams.agree, userAgreement)
      })
      .catch((error) => {
        this.showError(error)
        if (!callback) {
          return
        }
        callback(null)
      })
  }

  async performSaveUserAgreement(params) {
    const { db, user, agreement } = this.props
    if (!agreement) {
      throw new Error('No agreements')
    }
    const newData = Object.assign({}, params, { updated: Date.now() })
    await db
      .collection('user').doc(user.uid)
      .collection('agreement').doc(agreement.id)
      .set(newData)
    if (!params.agree) {
      await Promise.all((agreement.data.requirements || []).map((requirement) =>
        this.removeAgreementFiles(requirement)))
    }
    return {
      id: agreement.id,
      data: newData,
    }
  }

  async removeAgreementFiles(requirement) {
    const { user, agreement, storage } = this.props
    const path = `user/${user.uid}/agreement/${agreement.id}/${requirement.id}`
    const files = await storage.ref(path).listAll()
    await Promise.all(files.items.map((item) => storage.ref(item.fullPath).delete()))
  }

  isRequirementDisabled(requirementIndex, baseRequirementInputs) {
    const requirementInputs = baseRequirementInputs || (this.props.userAgreement || { data: {} }).data.requirements || {}
    const requirements = this.props.agreement.data.requirements || []
    return requirements
      .slice(0, requirementIndex)
      .some((requirement) => !requirementInputs[requirement.id])
  }

  toggleDetail(requirement) {
    const details = Object.assign({}, this.state.details)
    details[requirement.id] = !details[requirement.id]
    this.setState({ details, })
  }

  showError(error) {
    if (!this.props.onError) {
      console.error(error)
      return
    }
    this.props.onError(error)
  }

  renderRequirementControl(requirement, confirmed) {
    if (requirement.type === 'video') {
      return (<VideoAgreement
        confirmed={confirmed}
        requirement={requirement}
        onAgree={() => this.confirmRequirement(requirement)}
      />)
    }
    if (requirement.type === 'pdf') {
      return (<PDFAgreement
        confirmed={confirmed}
        requirement={requirement}
        onAgree={() => this.confirmRequirement(requirement)}
      />)
    }
    if (requirement.type === 'sign') {
      return (<SignAgreement
        storage={this.props.storage}
        user={this.props.user}
        agreement={this.props.agreement}
        uploaded={confirmed}
        requirement={requirement}
        onAgree={(value) => this.confirmRequirement(requirement, value)}
        onError={(error) => this.showError(error)}
      />)
    }
    if (confirmed) {
      return null
    }
    return (<Button variant='success' onClick={() => this.confirmRequirement(requirement)}>
      {requirement.confirm || '確認した'}
    </Button>)
  }

  renderRequirements() {
    const requirementInputs = (this.props.userAgreement || { data: {} }).data.requirements || {}
    const requirements = this.props.agreement.data.requirements || []
    return requirements.map((requirement, requirementIndex) => <Container className='AgreementRequirements'>
        {!this.isRequirementDisabled(requirementIndex) ? <>
            <h4 className={!requirementInputs[requirement.id] ? 'AgreementStepActive AgreementStep' : 'AgreementStep'}>
              <FontAwesomeIcon
                data-test-agreement-requirement-toggle={requirement.id}
                className={'AgreementOpen'}
                icon={requirementInputs[requirement.id] ? (this.state.details[requirement.id] ? faAngleDown : faAngleRight) : faInfoCircle}
                onClick={() => this.toggleDetail(requirement)}
              />
              {requirement.title}
            </h4>
            {(!requirementInputs[requirement.id] || this.state.details[requirement.id]) && <div className='AgreementStepDescription'>
              <Description markdown={requirement.description} />
              {this.renderRequirementControl(requirement, requirementInputs[requirement.id])}
            </div>}
          </> : <h4 className='AgreementStep AgreementStepDisabled'>{requirement.title}</h4>}
      </Container>)
  }

  renderAgree() {
    return (<>
      <Alert variant='danger'>
        <strong className='AgreementStatus'>実験 "{this.props.agreement.data.title}" への参加手続きが必要です</strong>
        このコンテンツを利用するには実験説明の確認・同意書の記入が必要です。
      </Alert>
      <Description markdown={this.props.agreement.data.description} />
      {this.props.agreement.data.requirements ?
        this.renderRequirements() :
        <Button
          data-test-agree
          variant='success'
          onClick={() => this.agree()}
        >同意する</Button>}
    </>)
  }

  renderDisagree() {
    return (<>
      <Alert variant='secondary'>
        <strong className='AgreementStatus'>実験 "{this.props.agreement.data.title}" への参加同意済み</strong>
        実験参加への同意はいつでも撤回可能です。
        <Button
          data-test-agree-detail-toggle={this.state.disagreeDetail}
          variant='link'
          onClick={() => this.setState({
            disagreeDetail: !this.state.disagreeDetail,
          })}
        >
          {this.state.disagreeDetail ? '詳細を隠す' : '詳細を表示する'}
        </Button>
      </Alert>
      {this.state.disagreeDetail && <>
          {this.props.agreement.data.requirements && this.renderRequirements()}
          <Button
            data-test-disagree
            variant='danger'
            onClick={() => this.setState({ disagreeConfirm: true })}
          >
            同意を撤回する
          </Button>
        </>}
    </>)
  }

  renderModals() {
    return (<>
      <Modal
        data-test-disagree-modal-confirm
        show={this.state.disagreeConfirm}
        animation={true}
        onHide={e => this.setState({ disagreeConfirm: false })}>
        <Modal.Header closeButton>
          <Modal.Title>撤回確認</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            同意を撤回してよろしいですか？<br/>
            同意を撤回された場合、データの分析は行いません。<br/><br/>
            同意はいつでも再度実施することができます。
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='light'
            data-test-disagree-confirm-cancel
            onClick={e => this.setState({ disagreeConfirm: false })}>
            キャンセル
          </Button>
          <Button
            variant='danger'
            data-test-disagree-confirm-ok
            disabled={this.state.disagreeing}
            onClick={e => this.disagree()}>
            {this.state.disagreeing ? '同意を撤回しています...' : '撤回'}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        data-test-agree-modal-confirm
        show={this.state.agreeResult}
        animation={true}
        onHide={e => this.setState({ agreeResult: false })}>
        <Modal.Header closeButton>
          <Modal.Title>ありがとうございました！</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            同意を受け付けました！<br/>
            Cloze Testが利用可能になりましたので、試してみてください！
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='light'
            data-test-agree-confirm-cancel
            onClick={e => this.setState({ agreeResult: false })}>
            閉じる
          </Button>
        </Modal.Footer>
      </Modal>
    </>)
  }

  render() {
    return <div className='AgreementRoot'>
      {this.props.needAgreement && this.renderAgree()}
      {!this.props.needAgreement && this.renderDisagree()}
      {this.renderModals()}
    </div>
  }
}

export default Agreement;
